import styled from '@emotion/styled';
import { pxToEm } from 'theme';
import palette from 'theme/palette';
import { Sizes } from './SimpleTab';

type ProjectItemType = { selected?: boolean; size: Sizes; disabled?: boolean };

export const ProjectItem = styled.div<ProjectItemType>`
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  max-width: ${pxToEm(400)};
  padding-left: ${({ size }) => pxToEm(size === Sizes.default ? 16 : 12)};
  padding-right: ${({ size }) => pxToEm(size === Sizes.default ? 16 : 12)};
  border-radius: ${pxToEm(24)};
  height: ${({ size }) => pxToEm(size === Sizes.default ? 36 : 28)};
  background-color: ${({ selected }) =>
    selected ? palette.primary.main : palette.secondary?.main};
  color: ${({ selected }) =>
    selected ? palette.common.white : palette.primary.main};
  user-select: none;
  pointer-events: ${({ disabled }) => (disabled ? 'none' : 'auto')};
  opacity: ${({ disabled }) => (disabled ? '0.5' : '1')};
  margin-right: 8px;

  & .badge {
    background: ${({ selected }) =>
      selected ? palette.common.white : palette.primary.main};
    border-radius: 8px;
    font-size: 10px;
    font-weight: 600;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    height: 16px;
    padding: 3px 5px 2px 5px;
    color: ${({ selected }) =>
      selected ? palette.primary.main : palette.common.white};
    margin-left: 8px;
    cursor: pointer;
  }

  & .tabIcon {
    margin-right: 5px;
    margin-left: -2px;
  }

  & .title {
    color: inherit;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    font-size: ${({ size }) => pxToEm(size === Sizes.default ? 16 : 14)};
  }
`;
